import { MetaData } from 'models/MetaData/metaData.model';

export interface CategoryOptions {
  value: string | undefined;
  label: string | undefined;
}

export interface CategoryOptionsGeneric<T = string> {
  value?: T;
  label?: string;
}

export const convertToOptions = (data: MetaData[]) => {
  const options: CategoryOptions[] = [];
  data?.map((item: MetaData) => {
    options.push({
      label: item.name,
      value: item?.id?.toString(),
    });
  });
  return options;
};

export const convertToOptionsGeneric = <T = string>(
  data: MetaData[]
): CategoryOptionsGeneric<T>[] => {
  return data?.map((item: MetaData) => ({
    label: item.name,
    value: item.id as T,
  }));
};
